import dayjs from 'dayjs';

const msInDay = 86400000;
const msInTwoDays = 172800000;
const msInWeek = 604800000;
const msInMonth = 2592000000;
const msInThreeMoth = 7776000000;

const getRange = deltaMs => {
  const now = Date.now();

  return {
    from: now - deltaMs,
    to: now,
  };
};

const getStrictDaysRange = deltaMs => {
  const { from, to } = getRange(deltaMs);

  return {
    from: dayjs(from).startOf('day').valueOf(),
    to: dayjs(to).endOf('day').valueOf(),
  };
};

export const getDayRange = () => getRange(msInDay);
export const getTwoDayRange = () => getRange(msInTwoDays);

export const getWeekRange = () => getStrictDaysRange(msInWeek);
export const getMonthRange = () => getStrictDaysRange(msInMonth);
export const getThreeMonthRange = () => getStrictDaysRange(msInThreeMoth);

export const last24 = 'last_24_hours';
export const last48 = 'last_48_hours';
export const rangeName = 'from';

export const dateRangeOptions = [last24, last48, rangeName];
// special bet status to show bets which are available for cashout
export const BET_STATUS_TO_SELL = 'BET_STATUS_TO_SELL';
export const BET_STATUS_ALL = 'BET_STATUS_ALL';
export const BET_STATUS_SETTLED = 'BET_STATUS_SETTLED';

export const betStatuses = {
  UNSETTLED: 'UNSETTLED',
  LOSE: 'LOSE',
  WIN: 'WIN',
  VOID: 'VOID',
  CASH_OUT: 'CASH_OUT',
  CANCELLED: 'CANCELLED',
};

const { UNSETTLED, LOSE, WIN, VOID, CASH_OUT, CANCELLED } = betStatuses;

export const betStatusesList = [WIN, UNSETTLED, VOID, LOSE, CANCELLED, CASH_OUT];

export const extendedBetStatuses = [BET_STATUS_ALL, BET_STATUS_TO_SELL, ...betStatusesList];

// actions
export const UPDATE_STATE = 'UPDATE_STATE';
export const REPLACE_BET = 'REPLACE_BET';
export const UPDATE_ORDER_CASHOUT_BET = 'UPDATE_ORDER_CASHOUT_BET';
export const SET_BETS = 'SET_BETS';
export const SET_BETS_BY_REQUEST_TIME = 'SET_BETS_BY_REQUEST_TIME';
export const SET_ORDER_CASHOUT_BETS = 'SET_ORDER_CASHOUT_BETS';
